<script setup lang="ts">
interface Props {
  statuses: string[];
  hasImmediateImpact?: boolean;
  hasPriorityAttention?: boolean;
}

defineProps<Props>();
</script>

<template>
  <div class="flex min-w-72 flex-col items-start gap-1.5">
    <div
      v-if="hasImmediateImpact || hasPriorityAttention"
      class="flex flex-wrap gap-1.5"
    >
      <span
        v-if="hasPriorityAttention"
        title="An immediate-impact issue that is paid or is not preemptible."
        class="inline-flex rounded-full bg-red-100 px-2 py-0.5 text-xs font-semibold text-red-800 ring-1 ring-inset ring-red-200"
      >
        Priority Attention
      </span>
      <span
        v-if="hasImmediateImpact"
        title="The contract is running today and currently has a posting or advertising assignment issue."
        class="inline-flex rounded-full bg-amber-100 px-2 py-0.5 text-xs font-semibold text-amber-800 ring-1 ring-inset ring-amber-200"
      >
        Immediate Impact
      </span>
    </div>
    <ul class="flex flex-col gap-1">
      <li
        v-for="status in statuses"
        :key="status"
        class="leading-5 text-gray-800"
      >
        {{ status }}
      </li>
    </ul>
  </div>
</template>
